/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Inventory_TitleInputs */



/**
* | output |
* | --- |
* | "Inventory" |
*
* @param {Promo_Inventory_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_inventory_title = /** @type {((inputs?: Promo_Inventory_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Inventory_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inventaire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inventario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inventário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inventario")
	return /** @type {LocalizedString} */ ("Inventory")
});